import type React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { SvgIconReact } from "components/SvgIconReact";

import {
  StyledBreadcrumbs,
  StyledButton,
  StyledUserAdminBreadcrumbs,
} from "./UserAdminBreadcrumbs.styled";

interface UserAdminBreadcrumbsProps {
  previousText: string;
  previousAdminUrl: string;
  previousRoutePath: string;
  previousRoutePathLabel: string;
  currentPagePath: string;
  currentPageLabel: string;
}

interface LocationState {
  params?: string;
}

export const UserAdminBreadcrumbs: React.FC<UserAdminBreadcrumbsProps> = ({
  previousText,
  previousAdminUrl,
  previousRoutePath,
  previousRoutePathLabel,
  currentPagePath,
  currentPageLabel,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <StyledUserAdminBreadcrumbs>
      <StyledButton
        dataCy="previous-page-button"
        variant="default"
        onClick={() => {
          const params = (location.state as LocationState)?.params ?? "";
          navigate(`${previousAdminUrl}/${params}`);
        }}
      >
        <SvgIconReact iconName="leftArrowIcon" />
        {previousText}
      </StyledButton>
      <StyledBreadcrumbs
        dataCy="admin-environment"
        routes={[
          {
            path: previousRoutePath,
            breadcrumb: previousRoutePathLabel,
          },
          {
            path: currentPagePath,
            breadcrumb: currentPageLabel,
          },
        ]}
        showAllRoutes={false}
      />
    </StyledUserAdminBreadcrumbs>
  );
};
